'use strict';

const getPrimitive = require('./getPrimitive');

/**
 * Returns true if the given object is a constructor function.
 * @param  {*}  func
 * @return {Boolean}
 */
module.exports = function isConstructor (func) {
  let funcPrimitive = getPrimitive(func);
  if (funcPrimitive && (typeof funcPrimitive === 'function')) {
    return ((typeof funcPrimitive.prototype) === 'object' || funcPrimitive === Function);
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isConstructor.js